/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { RecipientStatus } from './RecipientStatus';
import {
    RecipientStatusFromJSON,
    RecipientStatusFromJSONTyped,
    RecipientStatusToJSON,
    RecipientStatusToJSONTyped,
} from './RecipientStatus';

/**
 * 
 * @export
 * @interface Recipient
 */
export interface Recipient {
    /**
     * 
     */
    referral_id: string;
    /**
     * Opaque identifier for this recipient's participation in this referral. Use it as the thread key and as the recipient key in request paths. Stable for the life of the referral, but not comparable across referrals — use `provider_id` for that. Do not parse it; its representation will change.
     */
    participant_id: string;
    /**
     * Deprecated — use `participant_id` for the thread and `provider_id` for the partner. Null for an external recipient, which belongs to no organization here.
     * @deprecated
     */
    organization_id: string | null;
    /**
     * Deprecated — use `participant_id`. Null for an external recipient, which has no facility record.
     * @deprecated
     */
    facility_id?: string | null;
    /**
     * 
     */
    facility_name?: string | null;
    /**
     * Real provider_directory identifier. Null for an "other" recipient (a name+email contact with no directory-backed identity) — the only reliable "other" signal available to clients.
     */
    provider_id?: string | null;
    /**
     * 
     */
    status: RecipientStatus;
    /**
     * 
     */
    created_at: Date;
    /**
     * 
     */
    updated_at: Date;
    /**
     * Deprecated — use `has_unread`, which is computed from it. ULID of the most recent inbound message in this thread. Stamped by the message-create handler when the sender is a recipient facility.
     * @deprecated
     */
    last_inbound_message_id?: string | null;
    /**
     * True when this thread has an inbound message newer than the caller's read receipt for the thread. Per-thread; computed at read time from `last_inbound_message_id` vs the caller's per-thread receipt.
     */
    has_unread?: boolean;
    /**
     * Admission tracking state for this recipient. Free-form string; null when not yet set.
     */
    admission_status?: string | null;
}



/**
 * Check if a given object implements the Recipient interface.
 */
export function instanceOfRecipient(value: object): value is Recipient {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('participant_id' in value) || value['participant_id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    return true;
}

export function RecipientFromJSON(json: any): Recipient {
    return RecipientFromJSONTyped(json, false);
}

export function RecipientFromJSONTyped(json: any, ignoreDiscriminator: boolean): Recipient {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'participant_id': json['participant_id'],
        'organization_id': json['organization_id'],
        'facility_id': json['facility_id'] === undefined ? undefined : json['facility_id'] === null ? null : json['facility_id'],
        'facility_name': json['facility_name'] === undefined ? undefined : json['facility_name'] === null ? null : json['facility_name'],
        'provider_id': json['provider_id'] === undefined ? undefined : json['provider_id'] === null ? null : json['provider_id'],
        'status': RecipientStatusFromJSON(json['status']),
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'updated_at': (json['updated_at'] == null ? json['updated_at'] : parseDateTime(json['updated_at'])),
        'last_inbound_message_id': json['last_inbound_message_id'] === undefined ? undefined : json['last_inbound_message_id'] === null ? null : json['last_inbound_message_id'],
        'has_unread': json['has_unread'] == null ? undefined : json['has_unread'],
        'admission_status': json['admission_status'] === undefined ? undefined : json['admission_status'] === null ? null : json['admission_status'],
    };
}

export function RecipientToJSON(json: any): Recipient {
    return RecipientToJSONTyped(json, false);
}

export function RecipientToJSONTyped(value?: Recipient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'participant_id': value['participant_id'],
        'organization_id': value['organization_id'],
        'facility_id': value['facility_id'],
        'facility_name': value['facility_name'],
        'provider_id': value['provider_id'],
        'status': RecipientStatusToJSON(value['status']),
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
        'last_inbound_message_id': value['last_inbound_message_id'],
        'has_unread': value['has_unread'],
        'admission_status': value['admission_status'],
    };
}

